// src/components/PrivacyPolicy.js
import React from 'react';
import '../css/PrivacyPolicy.css'; // Link to the new CSS file

export default function PrivacyPolicy() {
    return (
        <div className="privacy-policy-wrapper">
            {/* Hero Banner */}
            <div className="privacy-banner">
                <h1>Privacy Policy</h1>
                <p>Your privacy is important to us.</p>
            </div>

            {/* Main Content Area */}
            <div className="privacy-content-container">
                <section className="privacy-section">
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to No Brokerage Paying Guest. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit or make a booking through our website. We are committed to protecting your privacy and ensuring you have a positive experience on our site.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>2. Information We Collect</h2>
                    <p>
                        We collect various types of information in connection with the services we provide, including:
                    </p>
                    <ul>
                        <li><strong>Personal Identification Information:</strong> Name, email address, phone number, and other contact details you provide when filling out forms or making inquiries.</li>
                        <li><strong>Demographic Information:</strong> Location preferences (e.g., Mumbai areas), sharing preferences (single, double, triple sharing).</li>
                        <li><strong>Technical Data:</strong> IP address, browser type, operating system, referral sources, website navigation paths, and time spent on pages. This information is collected automatically.</li>
                        <li><strong>Usage Data:</strong> Information about how you use our website, such as pages visited, properties viewed, and search queries.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes, including:</p>
                    <ul>
                        <li>To provide and maintain our services, including processing your inquiries and bookings.</li>
                        <li>To improve, personalize, and expand our website and services.</li>
                        <li>To understand and analyze how you use our website.</li>
                        <li>To communicate with you, including sending you updates, promotional materials, and responding to your inquiries.</li>
                        <li>To detect and prevent fraud and other illegal activities.</li>
                        <li>To comply with legal obligations.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>4. Data Security</h2>
                    <p>
                        We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information. However, no method of transmission over the Internet or method of electronic storage is 100% secure.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>5. Third-Party Links</h2>
                    <p>
                        Our website may contain links to third-party websites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>6. Your Choices</h2>
                    <p>You have certain rights regarding your personal information:</p>
                    <ul>
                        <li>You can opt-out of receiving promotional communications from us by following the unsubscribe link in those emails.</li>
                        <li>You can disable cookies through your browser settings.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us:
                    </p>
                    <ul>
                        <li>By email: <a href="mailto:swetarita25786@gmail.com">swetarita25786@gmail.com</a></li>
                        <li>By phone: <a href="tel:+918879779777">+91 8879779777</a></li>
                        <li>By visiting this page on our website: <a href="/contact">Contact Us</a></li>
                    </ul>
                </section>
            </div>
        </div>
    );
}